export default __webpack_public_path__ + "static/media/about-thumb-9-challenge.1819b3d6.jpeg";